import { render, staticRenderFns } from "./homeBrand.vue?vue&type=template&id=5eaa4d94&scoped=true&"
import script from "./homeBrand.vue?vue&type=script&lang=js&"
export * from "./homeBrand.vue?vue&type=script&lang=js&"
import style0 from "./homeBrand.vue?vue&type=style&index=0&id=5eaa4d94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaa4d94",
  null
  
)

export default component.exports